// Crédito BCMED na tela do pedido/proposta: a conta do limite (o backend confere de novo; o saldo é do nova_campanha).

// CPF (11) ou CNPJ (14) só com dígitos; senão null (sem documento não há crédito).
export const documentoDoCredito = (cpfCnpj) => {
  const digitos = String(cpfCnpj || '').replace(/\D/g, '');
  return digitos.length === 11 || digitos.length === 14 ? digitos : null;
};

// Teto da tela: o máximo do saldo (já com o % dos produtos), nunca acima dos produtos. null = saldo desconhecido.
export const limiteDoCredito = (saldo, subtotal) => {
  if (!saldo?.habilitado) return null;
  return Math.min(Number(saldo.maximo) || 0, Math.max(0, Number(subtotal) || 0));
};

const centavos = (v) => Math.round(v * 100) / 100;

// Valor digitado (aceita vírgula) em reais, entre 0 e o limite; `reduzido` quando passou do limite.
export const limitarCredito = (digitado, limite) => {
  const valor = Math.max(0, centavos(Number(String(digitado ?? '').replace(',', '.')) || 0));
  if (limite !== null && limite !== undefined && valor > limite) return { valor: limite, reduzido: true };
  return { valor, reduzido: false };
};

// O que vai no payload: zero sem documento válido ou no financiamento (a financeira paga o pedido inteiro).
export const creditoAplicado = ({ valor, documento, financiamento, limite }) => (
  documento && !financiamento ? limitarCredito(valor, limite).valor : 0
);

// 409 do saldo de crédito ao salvar ({codigo, mensagem, maximo}); outro erro = null.
export const erroDeCredito = (error) => {
  const detail = error?.response?.data?.detail;
  const doCredito = ['acima_do_maximo', 'ja_liquidado', 'recusado'];
  return error?.response?.status === 409 && doCredito.includes(detail?.codigo) ? detail : null;
};

// Itens do pedido para as regras do Cash Black (o backend converte em centavos): preço líquido e desconto por unidade.
export const itensDoCredito = (itens) => (itens || []).map((i) => ({
  sku: i.sku || '',
  quantidade: parseInt(i.quantidade, 10) || 0,
  preco_unitario: Math.max(0, Number(i.preco_unitario) || 0),
  desconto: Math.max(0, Number(i.desconto) || 0),
}));

// Por que o Cash Black não entra (regras.motivo do nova_campanha). Código desconhecido vira frase legível.
const MOTIVOS = {
  intervalo_15_dias: 'Cash Black usado há menos de 15 dias: só na próxima compra.',
  intervalo: 'Cash Black usado há menos de 15 dias: só na próxima compra.',
  teto_atingido: 'O desconto deste pedido já chegou ao teto: o Cash Black não entra.',
  teto: 'O desconto deste pedido já chegou ao teto: o Cash Black não entra.',
  sem_saldo: 'Cliente sem saldo de Cash Black.',
};
export const textoDoMotivo = (motivo) => {
  if (!motivo) return null;
  if (MOTIVOS[motivo]) return MOTIVOS[motivo];
  const texto = String(motivo).replace(/_/g, ' ');
  return texto.charAt(0).toUpperCase() + texto.slice(1);
};

const reaisOuNulo = (cents) => (cents === null || cents === undefined || Number.isNaN(Number(cents))
  ? null : Number(cents) / 100);

// Resposta do /credito-bcmed/simular (centavos do nova_campanha) para a tela; desligado = null.
export const resultadoDaSimulacao = (r) => (r?.habilitado ? {
  descontoVendedorMaximo: reaisOuNulo(r.descontoVendedorMaximoCents),
  credito: reaisOuNulo(r.creditoCents),
  precoSemCredito: reaisOuNulo(r.precoSemCreditoCents),
  precoComCredito: reaisOuNulo(r.precoComCreditoCents),
  saldoRestante: reaisOuNulo(r.saldoRestanteCents),
  motivo: textoDoMotivo(r.motivo),
  regulamentoUrl: r.regulamento_url || null,
} : null);

// Valor em R$ digitado no formato BR: "1.234" = 1234 (ponto seguido de 3 dígitos é milhar), "1.234,56", "1234,56";
// "1234.56" (ponto com 1 ou 2 casas) também vale. Vazio = null; qualquer outra coisa = NaN (erro no campo).
export const lerDinheiro = (texto) => {
  const t = String(texto ?? '').replace(/R\$/g, '').replace(/\s/g, '');
  if (!t) return null;
  if (/^\d{1,3}(\.\d{3})+(,\d{1,2})?$/.test(t) || /^\d+(,\d{1,2})?$/.test(t)) {
    return Number(t.replace(/\./g, '').replace(',', '.'));
  }
  return /^\d+\.\d{1,2}$/.test(t) ? Number(t) : NaN;
};
